import { loading } from '@/shared/utils/UIHelper'
import ClienteRHRepository from '@/shared/http/repositories/business/clientrh.js'
import ObraRepository from '@/shared/http/repositories/business/obrarh.js'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import WorkTypeRepository from '@/shared/http/repositories/business/worktype.js'
import CityRepository from '@/shared/http/repositories/geo/city'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import AccrediteddateRepository from '@/shared/http/repositories/realestate/accrediteddate'
import AccountRepository from '@/shared/http/repositories/access/account'
import Announcement from '@/shared/http/repositories/realestate/announcementRepository'
import documentsmanagement from '@/shared/http/repositories/realestate/documentsmanagement'
import broker from '@/shared/http/repositories/realestate/broker'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
import ProposalRepository from '@/shared/http/repositories/realestate/proposal'
import TechnicianRepository from '@/shared/http/repositories/realestate/technician'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
const BoardMixin = {
  methods: {
    onSearchClienteRH (value) {
      loading.push()
      ClienteRHRepository.GetAllByName(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.clienteRHTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeClienteRH (value) {
      loading.push()
      ClienteRHRepository.GetByCode(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.clienteRHTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchNomeMorador (value) {
      loading.push()
      OcurrenceRepository.GetByNameMorado(value)
        .then((response) => {
          this.$refs.NomeMoradoTypeahead.data = response.data
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onSearchObra (value) {
      loading.push()
      ObraRepository.GetAllByName(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.obraRHTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onSearchTechnician (value) {
      loading.push()
      TechnicianRepository.GetByName(value)
        .then((response) => {
          this.$refs.tecnicoTypeahead.data = response.data
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },

    onChangeCodeObra (value) {
      loading.push()
      ObraRepository.GetByCode(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.obraRHTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchResponsavel (value) {
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.responsavelTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeResponsavel (value) {
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.responsavelTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchResponsavelAll (value) {
      loading.push()
      EmployeeRepository.GetAllResponsavel(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.responsavelTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onSearchFavorecido (value) {
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.favorecidoTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeFavorecido (value) {
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.favorecidoTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchTipoObra (value) {
      loading.push()
      WorkTypeRepository.GetTipoObraByNome(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.TipoObraTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeTipoObra (value) {
      loading.push()
      WorkTypeRepository.GetTipoObraByNome(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.TipoObraTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchCidade (value) {
      loading.push()
      CityRepository.GetByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CidadeTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeCidade (value) {
      loading.push()
      CityRepository.GetByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CidadeTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchEmpreendimento (value) {
      loading.push()
      EnterpriseRepository.GetByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.EmpreendimentoTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeEmpreendimento (value) {
      loading.push()
      EnterpriseRepository.GetByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.EmpreendimentoTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchCliente (value) {
      loading.push()
      usermanagement.GetClienteByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ClienteTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onSearchUsuario (value) {
      loading.push()
      AccountRepository.GetCorretorByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ClienteTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeCliente (value) {
      loading.push()
      usermanagement.GetClienteByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ClienteTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchComission (value) {
      loading.push()
      CommissionRepository.GetCorretorByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CommissionTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeComission (value) {
      loading.push()
      CommissionRepository.GetCorretorByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CommissionTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchComissionClient (value) {
      loading.push()
      CommissionRepository.GetEmpreendimentoByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CommissionClientTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeComissionClient (value) {
      loading.push()
      CommissionRepository.GetEmpreendimentoByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CommissionClientTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchConta (value) {
      loading.push()
      AccountRepository.GetCorretorByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ContaTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeConta (value) {
      loading.push()
      AccountRepository.GetCorretorByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ClienteTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchImobliaria (value) {
      loading.push()
      AccrediteddateRepository.GetName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ImobliariaTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodoImobliaria (value) {
      loading.push()
      AccrediteddateRepository.GetName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ClienteTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },

    onSearchImobliariaVendas (value) {
      loading.push()
      ProposalRepository.GetCredenciadaByNameProposta(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ImobliariaVendasTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodoImobliariaVendas (value) {
      loading.push()
      ProposalRepository.GetCredenciadaByNameProposta(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ImobliariaVendasTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },

    onSearchDocumento (value) {
      loading.push()
      documentsmanagement.GetBynameDocuments(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.documentoTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodoDocumento (value) {
      loading.push()
      documentsmanagement.GetBynameDocuments(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.documentoTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchComunicado (value) {
      loading.push()
      Announcement.GetComunicadoByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ComunicadoTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeComunicado (value) {
      loading.push()
      Announcement.GetComunicadoByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ComunicadoTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchCorretor (value) {
      loading.push()
      broker.GetCorretorByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CorretorTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeCorretor (value) {
      loading.push()
      broker.GetCorretorByName(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CorretorTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchCorretorProposta (value) {
      loading.push()
      RequestsRepository.GetCorretorByNameProposta(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CorretorPropostaTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onSearchCorretorSalesReports (value) {
      loading.push()
      ProposalRepository.GetCorretorByNameSalesReports(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CorretorSalesReportsTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeCorretorProposta (value) {
      loading.push()
      RequestsRepository.GetCorretorByNameProposta(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CorretorPropostaTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchClienteProposta (value) {
      loading.push()
      RequestsRepository.GetClienteByNameProposta(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ClientePropostaTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeClienteProposta (value) {
      loading.push()
      RequestsRepository.GetClienteByNameProposta(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.ClientePropostaTypeahead.setValue(response.data.data)
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeCorretorSalesReports  (value) {
      loading.push()
      ProposalRepository.GetCorretorByNameSalesReports(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CorretorSalesReportsTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchCityByNameEnterprise (value) {
      loading.push()
      EnterpriseRepository.GetCityByNameEnterprise(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CityEnterpriseTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeCityByNameEnterprise (value) {
      loading.push()
      EnterpriseRepository.GetCityByNameEnterprise(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.CityEnterpriseTypeahead.setValue(response.data.data)
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onSearchUnidade (value) {
      loading.push()
      OcurrenceRepository.GetByNameUnidade(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.UnidadeTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    }
  }
}

export default BoardMixin



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js